var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ns-img',{staticClass:"image-logo",attrs:{"src":"/studio/logo/NeuralWorks_logo.png"}}),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("AI Studio")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }